module.exports = __webpack_public_path__ + "static/img/pageBg.4a1ef041.png";